<template>
    <div>
        <div style="display: flex; align-items: center; justify-content: space-between">
            <a-breadcrumb style="margin: 16px 0">
                <a-breadcrumb-item>主页</a-breadcrumb-item>
                <a-breadcrumb-item>{{ selectFirstMenu }}</a-breadcrumb-item>
                <a-breadcrumb-item>{{ selectSecondMenu }}</a-breadcrumb-item>
            </a-breadcrumb>
            <div>
                <a-button icon="sync" @click="apiPromotionStatistics">刷新</a-button>
            </div>
        </div>
        <a-collapse expandIconPosition="right" activeKey="1">
            <a-collapse-panel key="1" header="推广佣金统计查询">
                <div class="qinang-search-row">
                    <!-- 查询面板里的服务商筛选 -->
                    <!-- <div class="qinang-search-col-3">
						<div class="qinang-search-col-title">服务商：</div>
						<a-select v-model="facilitatorId" @change="facilitatorChange">
							<a-select-option :value="0">全部</a-select-option>
							<a-select-option v-for="(item, index) in facilitatorList" :key="index"
								:value="item.facilitatorId">{{ item.facilitatorName }}</a-select-option>
						</a-select>
					</div> -->

                    <div class="qinang-search-col-3" v-if="query.reportType == 1">
                        <div class="qinang-search-col-title">查询日期：</div>
                        <a-date-picker mode="date" v-model="query.startDay" valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" class="qinang-search-time-picker-2" />
                        <span style="width: 20px; text-align: center">-</span>
                        <a-date-picker mode="date" v-model="query.endDay" valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" class="qinang-search-time-picker-2" />
                    </div>
                    <div class="qinang-search-col-3" v-if="query.reportType == 2">
                        <div class="qinang-search-col-title">查询日期：</div>
                        <a-month-picker v-model="query.startMonth" valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM" class="qinang-search-time-picker-2" :showToday="false" />
                        <span style="width: 20px; text-align: center">-</span>
                        <a-month-picker v-model="query.endMonth" valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM" class="qinang-search-time-picker-2" :showToday="false" />
                    </div>
                    <div class="qinang-search-col-3" v-if="query.reportType == 3">
                        <div class="qinang-search-col-title">查询年份：</div>
                        <a-select v-model="query.startYear" class="qinang-search-select-2">
                            <a-select-option v-for="(item, index) in yearList" :key="index" :value="item">{{ item }}</a-select-option>
                        </a-select>
                    </div>
                    <div class="qinang-search-col-3">
                        <div class="qinang-search-col-title">报表类型：</div>
                        <a-radio-group v-model="query.reportType" style="margin-left: 14px">
                            <a-radio :value="1">日报表</a-radio>
                            <a-radio :value="2">月报表</a-radio>
                            <a-radio :value="3">年报表</a-radio>
                        </a-radio-group>
                    </div>
                    <div class="qinang-search-col-3"></div>
                </div>
                <div class="qinang-margin-top-12 qinang-search-row" style="justify-content: center">
                    <a-button type="primary" icon="search" @click="apiPromotionStatistics">查询</a-button>
                    <a-button icon="redo" @click="resetQuery" style="margin-left: 14px">重置</a-button>
                </div>
            </a-collapse-panel>
        </a-collapse>

        <div class="qinang-card" loading="tableLoading">
            <div style="width: 100%; text-align: center; margin: 20px; font-size: 16px">推广佣金统计表</div>
            <div style="margin: 0 40px 20px; text-align: right">
                <span> {{ queryDate }} </span>
                <span style="margin-left: 20px">报表类型：{{ queryType }}</span>
            </div>
            <div style="margin: 20px 40px; overflow-x: auto">
                <table id="reportTable" class="qa-ticket-sales-table" style="width: 100%; border-collapse: collapse">
                    <thead>
                        <tr>
                            <th class="qa-th-merged">交易日期</th>
                            <th class="qa-th-merged">入账笔数</th>
                            <th class="qa-th-merged">入账金额(元)</th>
                            <th class="qa-th-merged">提现笔数</th>
                            <th class="qa-th-merged">提现金额(元)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(tr, index) in tableData" :key="index">
                            <template v-for="(td, tdIndex) in row">
                                <td v-if="td.colspan > 0" :key="tdIndex" :rowspan="td.rowspan" :colspan="td.colspan" :class="td.class">
                                    {{ td.value }}
                                </td>
                            </template>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div style="margin: 20px 40px; text-align: right">
                <span>制表人：{{ staffName }}</span>
                <span style="margin-left: 20px">打印时间：{{ moment().format("YYYY-MM-DD HH:mm:ss") }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import FileSaver from "file-saver"
import * as XLSX from "xlsx"
import moment from "moment"
import { parseTableData } from "./PromotionReport"
export default {
    data() {
        return {
            moment,
            selectFirstMenu: window.sessionStorage.getItem("selectFirstMenu"),
            selectSecondMenu: window.sessionStorage.getItem("selectSecondMenu"),
            staffName: window.sessionStorage.getItem("staffName") || "测试",
            query: {
                page: 1,
                size: 10,
                total: 0,
                // 预留：推广人姓名筛选（前端暂未启用）
                promoterName: undefined,
                startDay: moment().format("YYYY-MM-DD") + " 00:00:00",
                endDay: moment().format("YYYY-MM-DD") + " 23:59:59",
                startMonth: moment().format("YYYY-MM") + "-01 00:00:00",
                endMonth: moment().format("YYYY-MM") + "-01 23:59:59",
                startYear: moment().format("YYYY"),
                reportType: 1
            },
            tableData: [],
            apiReturnData: [],
            yearList: [2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030],
            tableLoading: false,
            queryDate: "",
            queryType: ""
        }
    },
    methods: {
        parseTable() {
            let tableData = parseTableData(this.apiReturnData)
            this.tableData = tableData
        },
        async apiPromotionStatistics() {
            let queryData = this.query
            //  queryData.facilitatorId = this.facilitatorId
            switch (this.query.reportType) {
                case 1:
                    queryData.startDay = this.moment(this.query.startDay).format("YYYY-MM-DD") + " 00:00:00"
                    queryData.endDay = this.moment(this.query.endDay).format("YYYY-MM-DD") + " 23:59:59"
                    break
                case 2:
                    queryData.startMonth = this.moment(this.query.startMonth).format("YYYY-MM") + "-01 00:00:00"
                    queryData.endMonth = this.moment(this.query.endMonth).format("YYYY-MM") + "-01 23:59:59"
                    break
                case 3:
                    queryData.startYear = this.query.startYear
                    break
            }
            this.tableLoading = true
            const { data: res } = await this.$http.post(this.navigation.apiPromotionStatistics, queryData)
            if (res.code == 200) {
                this.apiReturnData = res.data
                this.parseTable()
                switch (this.query.reportType) {
                    case 1:
                        this.queryDate = this.moment(this.query.startDay).format("YYYY-MM-DD") + " 至 " + this.moment(this.query.endDay).format("YYYY-MM-DD")
                        break
                    case 2:
                        this.queryDate = this.moment(this.query.startMonth).format("YYYY-MM") + " 至 " + this.moment(this.query.endMonth).format("YYYY-MM")
                        break
                    case 3:
                        this.queryDate = this.query.startYear + "年"
                        break
                }
                this.queryType = this.query.reportType == 1 ? "日报表" : this.query.reportType == 2 ? "月报表" : "年报表"
                this.tableLoading = false
            } else {
                this.$message.error(res.msg)
                this.tableLoading = false
            }
        },
        resetQuery() {
            this.query = {
                page: 1,
                size: 10,
                total: 0,
                promoterName: undefined,
                startDay: moment().format("YYYY-MM-DD") + " 00:00:00",
                endDay: moment().format("YYYY-MM-DD") + " 23:59:59",
                startMonth: moment().format("YYYY-MM") + "-01 00:00:00",
                endMonth: moment().format("YYYY-MM") + "-01 23:59:59",
                startYear: moment().format("YYYY"),
                reportType: 1
            }
            // this.facilitatorId = 0
            // this.selectedFacilitatorName = '全部'
        },
        // 加载当前用户可见的服务商列表
        async loadFacilitators() {
            const { data: res } = await this.$http.post(this.navigation.apiFacilitatorListForStaff, {
                staffId: window.sessionStorage.getItem("staffId")
            })
            if (res.code === 200) {
                this.facilitatorList = res.data
            }
        },

        // 切换服务商时
        facilitatorChange(e) {
            if (e == 0) {
                this.selectedFacilitatorName = "全部"
            } else {
                const f = this.facilitatorList.find(item => item.facilitatorId == e)
                this.selectedFacilitatorName = f ? f.facilitatorName : "全部"
            }
        }
    },
    created() {
        this.apiPromotionStatistics()
        this.loadFacilitators()
    }
}
</script>

<style scoped>
.qa-ticket-sales-table {
    border: 1px solid #000;
}

.qa-th-merged {
    text-align: center;
    border: 1px solid #000;
    background-color: #d3e0f0;
    padding: 5px;
    color: #000;
}

.qa-td-merged {
    text-align: center;
    border: 1px solid #000;
    padding: 5px;
    vertical-align: middle;
    color: #000;
}

.qa-td-normal {
    text-align: center;
    border: 1px solid #000;
    padding: 5px;
    color: #000;
}

.qa-td-subtotal {
    text-align: center;
    border: 1px solid #000;
    padding: 5px;
    background-color: #e7edf4;
    font-weight: bold;
    color: #000;
}

.qa-td-total {
    text-align: center;
    border: 1px solid #000;
    padding: 5px;
    background-color: #e0e7f3;
    font-weight: bold;
    color: #000;
}
</style>
